import { faAngleRight } from "@jewlr/pro-light-svg-icons/faAngleRight"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Link } from "react-router-dom"

import { deactivateSubmenu } from "app-store-v2/app/actions"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Image from "components/ui/image"
import useNavigation from "helpers/use-navigation"
import { cn } from "styles/utils"

const InternalDropdownContent = ({
  dropdownColNum,
  dropdownMenu,
  leftMenu,
}) => {
  const keyboardProps = useNavigation({
    direction: "both",
    onEscape: () => leftMenu(),
  })

  return (
    <div
      className="contained-wide min-h-340 tablet:px-12 xlarge:px-0 grid grid-cols-5 justify-between"
      {...keyboardProps}
    >
      {dropdownMenu.sections &&
        dropdownMenu.sections.map((section, index) => (
          <div
            className={cn(
              "border-grey-10 my-35 pl-25 flex min-w-[16%] flex-col border-l pr-10 first:border-l-0 first:pl-10",
              section.style?.colStyle?.className
            )}
            key={"d" + index}
          >
            <h3
              aria-label={`${dropdownMenu.name} ${section.title}`}
              className="text-16 mb-10 min-h-20 font-normal uppercase text-black"
              id={`nav_col_${section.title}`}
            >
              {section.title}
            </h3>
            <ul
              aria-labelledby={`nav_col_${section.title}`}
              className="list-none"
              role="menu"
            >
              {section.links
                .filter(
                  (link) => typeof link.show === "undefined" || !!link.show
                )
                .map((link, j) => (
                  <li key={"l" + j} role="none">
                    <Link
                      className={cn(
                        "hover:text-primary focus-visible:text-primary text-14 tracking-half ml-8 inline-block min-w-10 py-5 capitalize hover:underline focus-visible:underline",
                        link.style?.className
                      )}
                      data-cy={`header-menu-dropdown-${link.name}-desktop`}
                      data-lc="menu"
                      role="menuitem"
                      to={link.url}
                    >
                      <span
                        dangerouslySetInnerHTML={{
                          __html: link.name,
                        }}
                      />{" "}
                      {link.is_new && (
                        <span className="text-sale ml-4">New!</span>
                      )}
                    </Link>
                  </li>
                ))}
            </ul>
          </div>
        ))}
      {dropdownMenu.images &&
        dropdownMenu.images.map((image, index) => (
          <Link
            className={cn(
              "mt-35 group mb-16 text-center",
              !dropdownMenu.categories &&
                "flex flex-col justify-center p-10 focus:opacity-60",
              dropdownColNum + index > 4 && "tablet:hidden desktop:block"
            )}
            data-lc="menu"
            key={"d" + index}
            role="menuitem"
            to={image.url}
          >
            <Image
              alt={image.alt}
              className="mx-auto mb-16"
              fallback={image.fallback}
              height="905"
              srcSet={image.srcSet}
              style={{ width: "225px" }}
              width="865"
            />
            {!!image.title && (
              <p className="group-hover:text-primary group-focus-visible:text-primary text-14 flex items-center justify-center group-hover:underline group-focus-visible:underline">
                <FontAwesomeIcon className="text-6 mr-8" icon={faAngleRight} />
                {image.title}
              </p>
            )}
          </Link>
        ))}
    </div>
  )
}

InternalDropdownContent.propTypes = {
  dropdownColNum: PropTypes.number,
  dropdownMenu: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  leftMenu: PropTypes.func,
}

const getColNum = (state) => {
  const content = state.menu.submenu
  if (content) {
    return Object.keys(content).length
  }
  return 0
}

const mapStateToProps = (state, ownProps) => {
  return {
    dropdownColNum: getColNum(state, ownProps),
    dropdownMenu: state.menu.desktopSubmenu,
  }
}

const mapDispatchToProps = (dispatch) => ({
  leftMenu: () => dispatch(deactivateSubmenu()),
})

const DropdownContent = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalDropdownContent)

export default DropdownContent
